import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { CommunicationView } from '@/features/jobs/details/components/CommunicationView'
import { JobConversationContainer } from '@/features/jobs/details/components/JobConversationContainer'

export interface CommunicationViewContainerProps {
  vm: JobDetailsViewModel
}

export const CommunicationViewContainer = observer(
  function CommunicationViewContainer({ vm }: CommunicationViewContainerProps) {
    return (
      <CommunicationView>
        <JobConversationContainer vm={vm} showDocumentTabOnUpload={false} />
      </CommunicationView>
    )
  },
)
